export const areArraysIdentical = (arr1, arr2) => {
  return (
    arr1?.length > 0 &&
    arr2?.length === arr1?.length &&
    arr2.join('') === arr1.join('')
  );
};
